/* eslint-disable react-refresh/only-export-components */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserStore } from '@/store';

const isString = (value: any) => typeof value === 'string';

const defaults = {
  AuthenticatingComponent: () => null, // Don't render anything while authenticating
  FailureComponent: () => null, // Don't render anything on failure of the predicate
  wrapperDisplayName: 'AuthWrapper',
};

const Redirect = ({ path }: any) => {
  const navigate = useNavigate();
  useEffect(() => {
    if (typeof path === 'object' && path !== null && isString(path.search)) {
      navigate(`${path.pathname}?${path.search}`);
    } else {
      navigate(path);
    }
  }, [navigate, path]);

  return null;
};

const AuthHandler = ({ DecoratedComponent, AuthenticatingComponent, redirectPath, shouldComponentRender, isLoading, ...props }: any) => {
  const userStore = useUserStore();
  if (shouldComponentRender && shouldComponentRender(userStore)) {
    return <DecoratedComponent {...props} />;
  } else if (isLoading && isLoading(userStore)) {
    return <AuthenticatingComponent {...props} />;
  } else {
    return <Redirect path={redirectPath()} />;
  }
};

AuthHandler.displayName = 'AuthHandler';

const AuthWrapper = (conf: any) => (DecoratedComponent: any) => <AuthHandler {...conf} DecoratedComponent={DecoratedComponent} />;

export default (args: any) => {
  return AuthWrapper({
    ...defaults,
    ...args,
  });
};
